module.exports = __webpack_public_path__ + "static/media/ibd_back2.73cc81d7.png";